var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialNetworkSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Social Network Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.28,21.37H8.37A1.78,1.78,0,0,1,6.6,19.6V12a1.78,1.78,0,0,1,1.77-1.77h42A1.77,1.77,0,0,1,52.09,12V32.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "6.68 24.4 6.68 47.66 26.9 47.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.7,
    y1: 17.33,
    x2: 42.99,
    y2: 17.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.98,
    y1: 14.03,
    x2: 39.71,
    y2: 14.03
  }), /*#__PURE__*/React.createElement("g", {
    id: "settings"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.69,45.85V42.39H50.05a8.55,8.55,0,0,0-1.19-2.94l2.59-2.6L49,34.4,46.44,37a8.52,8.52,0,0,0-3.14-1.33V32H39.83v3.64a8.52,8.52,0,0,0-3,1.26L34.3,34.4l-2.46,2.45,2.49,2.49a8.76,8.76,0,0,0-1.26,3H29.43v3.46h3.64A8.92,8.92,0,0,0,34.4,49l-2.55,2.56L34.3,54l2.6-2.6a8.6,8.6,0,0,0,2.93,1.2v3.64H43.3V52.61a8.78,8.78,0,0,0,3-1.26L49,54l2.45-2.45-2.66-2.67a8.52,8.52,0,0,0,1.26-3ZM41.56,49.32a5.2,5.2,0,1,1,5.2-5.2A5.22,5.22,0,0,1,41.56,49.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialNetworkSettings01);
export default __webpack_public_path__ + "static/media/Social_Network_Settings_01.4c01c1e941fd47ca788ffbd38c35352e.svg";
export { ForwardRef as ReactComponent };